/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/
import { DashboardOptions } from '@uppy/dashboard';
import { UppyAllowedFileTypes, BulbFileRestrictions } from './types';

/**
 * Uppy dashboard option.
 * https://uppy.io/docs/dashboard/#Options
 */
export const UPPY_DASHBOARD_OPTIONS: DashboardOptions = {
  id: 'Dashboard',
  target: '#uppy-target',
  inline: false,
  showProgressDetails: true,
  hideRetryButton: false,
  hidePauseResumeButton: false,
  hideCancelButton: false,
  hideProgressAfterFinish: false,
  closeModalOnClickOutside: false,
  closeAfterFinish: false,
  disableStatusBar: false,
  disableInformer: false,
  disableThumbnailGenerator: false,
  disablePageScrollWhenModalOpen: true,
  animateOpenClose: true,
  fileManagerSelectionType: 'files',
  proudlyDisplayPoweredByUppy: false,
  showSelectedFiles: true,
  showRemoveButtonAfterComplete: false,
  browserBackButtonClose: false,
  theme: 'light',
  autoOpenFileEditor: false,
  disableLocalFiles: false,
};

/**
 * Set of default file restrictions used if none are provided
 */
export const DEFAULT_FILE_RESTRICTIONS: BulbFileRestrictions = {
  maxNumberOfFiles: 1,
  allowedFileTypes: [UppyAllowedFileTypes.ANY],
};

/**
 * Default Uppy Webcam plugin options.
 */
export const WebcamOptions = {
  countdown: false,
  mirror: true,
  videoConstraints: {
    facingMode: 'user',
  },
  preferredImageMimeType: 'image/jpeg',
  preferredVideoMimeType: 'video/x-matroska',
  showRecordingLength: true,
  showVideoSourceDropdown: true,
  modes: undefined,
  target: undefined,
};

/**
 * Language map for loading correct translation file.
 */
export const LANGUAGE_MAP = {
  de: 'de_DE',
  en: 'en_US',
  es: 'es_ES',
  fi: 'fi_FI',
  fr: 'fr_FR',
  nl: 'nl_NL',
  no: 'nb_NO',
  pt: 'pt_PT',
  sv: 'sv_SE',
};
